
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.css";
import { makeStyles } from '@material-ui/core/styles';
import MaterialUISwitch from './Pages/MuiTaggle';




function NavBar({darkMode, setDarkMode}) {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);


  const useStyles = makeStyles((theme) => ({}));

  const classes = useStyles();

  return (
    <>
      <nav className={`navbar ${darkMode ? 'navbar-dark' : 'navbar-light'}`}>

        <div className="nav-container">


          <NavLink exact to="/" className="nav-logo">
            Hernan
            <i className="fas fa-code"></i>
          </NavLink>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/projects"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/blog"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Blog
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/contact"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Contact
              </NavLink>
            </li>
            <li className="nav-item">

            <MaterialUISwitch
              activeClassName="active"
              className="material-ui-switch"
              onClick={() => setDarkMode(!darkMode)}>
              {darkMode ? "Light Mode" : "Dark Mode"}
            </MaterialUISwitch>
{/*
            <MaterialUISwitch
              className="material-ui-switch"
              onClick={() => setDarkMode(!darkMode)}>
              {darkMode ? "Light Mode" : "Dark Mode"}
            </MaterialUISwitch> */}

            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavBar;
